module.exports = __webpack_public_path__ + "img/back_arrow.d2624c71.svg";